export default "__VITE_ASSET__XmZkkdHA__"